export default {
    'Karmiel': 'Кармиэль',
    'Home': 'Главная',
    'Info': 'Инфо',
    'Map': 'Карта',
    'Profile': 'Профиль',
    'Log In': 'Вход',
    'General': 'Главная',
    'Settings': 'Настройки',
    'Logout': 'Выход',
    'Login': 'Войти',
    'Password': 'Пароль',
    'Email address': 'Адрес электронной почты',
    'Enter email': 'Введите адрес электронной почты',
    'Forgot password?': 'Забыли пароль?',
    'OR': "ИЛИ",
    'Sign Up': 'Зарегистрироваться',
    'Empty email': 'Пустой адрес электронной почты',
    'Invalid email format': 'Неверный формат адреса электронной почты',
    'Empty password': 'Пароль не указан',
    'Logging in...': 'Выполняется вход...',
    'Passwords don\'t match': 'Пароли не совпадают',
    'Creating new account...': 'Создание нового аккаунта...',
    'Failed to create account:': 'Не удалось создать аккаунт:',
    'Confirm Password': 'Подтвердите пароль',
    'Cancel': 'Отмена',
    'Change Password': 'Изменить пароль',
    'Delete Account': 'Удалить аккаунт',
    'My Rewards': 'Мои награды',
    'My Wallet': 'Мой кошелёк',
    'All Rewards': 'Все награды',
    'Shops': 'Магазины',
    'Family Park': 'Семейный парк', 
    'Retro Cars': 'Ретро авто',
    'Sculptures': 'Скульптуры',
    'Dance Festival': 'Город танцует',
    'Beyond Streets': 'Загляни за..',
    'City Zoo': 'Зоопарк',
    'Space Aliens': 'Космические пришельцы',
    'Assemble JWST': 'Собери JWST',
    'Quests': 'Квесты',
    'Rewards': 'Награды',
    'Public Art': 'Искусство',
    'Karmiel Digital': 'Кармиэль Диджитал',
    //settinds
    'Current Password': 'Текущий пароль',
    'New Password': 'Новый пароль',
    'Confirm New Password': 'Подтвердите новый пароль',
    'Change Password': 'Изменить пароль',
    'Enter Your Password': 'Введите свой пароль',
    'Delete Account': 'Удалить аккаунт',
    'Save Changes': 'Сохранить изменения',
    'Display Name': 'Публичное имя',
    //categories
    'Activities': 'Активности',
    'All': 'Все',
    'Storyville': 'Сторивилл',
    'Music Therapy': 'Музыкальная терапия',
    'Heritage Trail': 'Тропа наследия',
    'Gillie and Marc': 'Гилли и Марк',
    'ArtWall': 'Художественная стена',
    'Tree Watering': 'Полив деревьев',
    'Maps': 'Карты',
    'Teachable': 'Обучающее',
    'Not Here': 'Не здесь',
    'Games': 'Игры',
    'PerX Partners': 'Партнёры PerX',
    //sliders
    'onboarding_slide1_title': 'Добро пожаловать в DimensionX!',
    'onboarding_slide1_description': 'Мир, где цифровое и физическое пространство встречаются. DimensionX — это окно в мир дополненной реальности (AR), встроенной в окружающий вас реальный мир.',
    'onboarding_slide2_title': 'Исследуйте места с поддержкой AR',
    'onboarding_slide2_description': 'Откройте карту, чтобы найти ближайшие локации с дополненной реальностью. Инфо-значки и фото-подсказки помогут вам ориентироваться и попасть в нужное место.',
    'onboarding_slide3_title': 'Погрузитесь в цифровой мир',
    'onboarding_slide3_description': 'Когда вы окажетесь на месте, откройте камеру в приложении и плавно проведите телефоном из стороны в сторону. Контент дополненной реальности появится, как только приложение определит вашу локацию.',
    'onboarding_slide4_title': 'Собирайте бонусы',
    'onboarding_slide4_description': 'Во время исследования AR-пространства ищите золотые монеты! Нажимайте на них, как только увидите.',
    'onboarding_slide5_title': 'Готовы обменять бонусы?',
    'onboarding_slide5_description': 'Откройте свой AR-кошелёк в приложении, чтобы посмотреть собранные монеты и получить эксклюзивные предложения от локальных партнёров.',
    'NEXT': 'ДАЛЕЕ',
    'GET STARTED': 'НАЧАТЬ',
    'Skip': 'Пропустить'
}